import classNames from 'classnames';

import { useThemeClassName } from '../../contexts/ThemeContext';
import QuestionResult from '../items/QuestionResult';

import styles from '../../../styles/lists/questions-results.module.scss';

type QuestionsResultsProps = {
    questions?: Question[] | null;
    answers?: ParticipationAnswer[] | null;
    itemComponent?: string | null;
    withQuestionBody?: boolean;
    withValidAnswer?: boolean;
    withLongAnswer?: boolean;
    withExplanation?: boolean;
    className?: string | null;
};

function QuestionsResults({
    questions = null,
    answers = null,
    itemComponent = null,
    withQuestionBody = false,
    withValidAnswer = false,
    withLongAnswer = false,
    withExplanation = false,
    className = null,
}: QuestionsResultsProps) {
    const themeClassName = useThemeClassName(styles);

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.results}>
                {(questions || []).map((question, index) => {
                    const { id } = question;
                    const answer = answers?.find((a) => a.question === id) || null;
                    return (
                        <QuestionResult
                            key={`question-${id}`}
                            component={itemComponent}
                            index={index}
                            question={question}
                            answer={answer}
                            withQuestionBody={withQuestionBody}
                            withValidAnswer={withValidAnswer}
                            withLongAnswer={withLongAnswer}
                            withExplanation={withExplanation}
                            className={styles.result}
                        />
                    );
                })}
            </div>
        </div>
    );
}

export default QuestionsResults;
